<template>
  <div class="pa-7" id="support-top">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--カードコンポーネントをfor文で増やす-->
    <v-row>
      <v-col
      :cols="item.col"
      v-for="(item, i) in contents"
      :key="i"
      col="12">
        <v-card
        class="pa-5 ma-2"
        height="100%"
        elevation="5">
          <!--タイトル-->
          <v-card-title
          class="head2">
            {{ item.title }}
          </v-card-title>
          <!--サブタイトル-->
          <v-card-subtitle v-if="item.hasSubtitle">
            {{ item.subtitle }}
          </v-card-subtitle>
          <!--箇条書き部分-->
          <!-- <div
          v-for="(list, i) in item.content"
          :key="i"
          class="pt-2 ml-1">
            {{ list.li }}
          </div> -->
          <div
          v-for="(list, i) in item.content"
          :key="i"
          class="pt-2 ml-1"
          v-html="list.li">
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}

.link-button {
  display: inline-block;
  background-color: #1976D2;
  color: white!important;
  padding: 6px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.3s;
  border-radius: 28px;
}
.link-button:hover {
  background-color: #125ea9;
}

</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '',
      // タイトル横のアイコン
      icon: '',
      // カードコンポーネントの内用
      contents: [
        {
          // 幅(最大12)
          col: '12',
          xl: '6',
          // タイトル
          title: '学会ホームページ制作',
          // サブタイトルがあるか
          hasSubtitle: 'true',
          subtitle: 'ページ数8頁、8カ月の更新サポート 7万8千円',
          // 箇条書きの内容
          content: [
            {
              li: 'デザインにポスターを利用した場合、ページ数8頁、8カ月の更新サポートで7万8千円になります。更新は弊社にWord等で内容を送信いただきましたら、更新いたします。'
            },
            {
              li: '多くの医療関係の学会のホームページを作成、運用してきた経験から学会のホームページを低コストに作成、運用を行います。'
            },
            {
              li: 'UMINサーバーを利用できる場合は、UMINサーバーへの申請代行も行います。UMINサーバー利用の場合ドメイン費用、サーバーの月額料金は、かかりません。'
            },
            {
              li: 'ページの更新は、サポート期間内何度でもこちらで対応いたします！'
            },
            {
              li: 'コストに応じてドメイン費用、サーバー月額料金のかからないWixを利用したHPなどもご紹介できます。低コストに抑えたい場合、運用コストへの不安がありましたら、ご相談ください。<br><br><a href=\'/Service/supportConference#support-performance\' target="_blank" class="link-button">実績は、こちら</a>'
            }
          ]
        },
        {
          // 幅(最大12)
          col: '12',
          // タイトル
          title: '演題登録システム',
          // サブタイトルがあるか
          hasSubtitle: 'true',
          subtitle: 'サーバー手配、保守運用・更新サポート付き',
          // 箇条書きの内容
          content: [
            {
              li: '演題数、演題登録方法に合わせて作成いたします。費用も、ご相談ください。'
            },
            {
              li: '多くの医療系学術大会の実績があります。演題入力フォーム、管理方法、出力方法についてもカスタムいたします。'
            },
            {
              li: '演題登録システムのご利用についても、低コストに作成、運用をサポートいたします。その他ご要望に応じたシステムのカスタムもいたします。<br><br><a href="/Products/registration" target="_blank" class="link-button">詳しくは、こちら</a>'
            }
          ]
        },
        {
          // 幅(最大12)
          col: '12',
          xl: '6',
          // タイトル
          title: '事前参加システム',
          // サブタイトルがあるか
          hasSubtitle: 'true',
          subtitle: 'サーバー手配、保守運用・更新サポート付き',
          // 箇条書きの内容
          content: [
            {
              li: '学会の規模に合わせて作成いたします。費用も、ご相談ください。'
            },
            // {
            //   li: 'UMIN（大学病院医療情報ネットワーク ）を利用できる場合は、UMINへの申請代行も行います。UMINの演題抄録登録システムの運用代行も行います。<a href=\'/Service/supportConference#support-price\' target="_blank" class="link-button">詳しくは、こちら</a>'
            // },
            {
              li: '事前参加システムのご利用についても、低コストに作成、運用をサポートいたします。'
            },
            {
              li: '多くの医療関係学術大会の実績があります。セキュリティ対策についても、お任せください。'
            },
            {
              li: '事前参加登録については、決済方法に合わせてコストのかからない方法もご提案いたします。システムのカスタムもいたします。<br><br><a href=\'/Products/participation\' target="_blank" class="link-button">詳しくは、こちら</a>'
            }
          ]
        }
      ]
    }
  }
}
</script>
